import { render, staticRenderFns } from "./PromocodeItem.vue?vue&type=template&id=4199831c&scoped=true"
import script from "./PromocodeItem.vue?vue&type=script&lang=js"
export * from "./PromocodeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4199831c",
  null
  
)

export default component.exports